<script setup lang="ts">
    import { useRoute } from 'vue-router';
    import EchoButton from '../components/EchoButton.vue';
    import SettingsPageLayout from '../components/settings/SettingsPageLayout.vue';
    import { __ } from '../stores/expressions';
    import CoachingFormDetail from '../components/coaching/CoachingFormDetail.vue';
    import { ChevronLeftIcon, PencilIcon } from '@lucide/vue';

    const route = useRoute();
</script>
<template>
    <SettingsPageLayout>
        <template #header>
            <h1 class="heading-lg-light">{{ __('settings-manage-forms') }}</h1>
        </template>
        <template #topbar>
            <EchoButton
                variant="primary"
                :route="'/settings/manage-forms/' + route.params.id + '/edit'"
            >
                {{ __('edit-coaching-form-edit-form') }}
                <template #icon-right><PencilIcon /></template>
            </EchoButton>
        </template>
        <template #content>
            <EchoButton size="large" variant="tertiary" route="/settings/manage-forms">
                <template #icon-left><ChevronLeftIcon /></template>
                {{ __('all-forms') }}
            </EchoButton>
            <div class="pt-5">
                <CoachingFormDetail />
            </div>
        </template>
    </SettingsPageLayout>
</template>
